import { Navigate, Outlet } from "react-router-dom";

import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { ScreenLoaderLogo } from "~/components/screen/screen-loader-logo";

export const TicketValidationLayoutPage = () => {
  const { data: till, status } = useCurrentTill();

  if (status === "pending") {
    return <ScreenLoaderLogo />;
  }

  if (status === "error") {
    return <Navigate to="/home" />;
  }

  if (till.type !== "ticket-validation") {
    return <Navigate to="/home" />;
  }

  return <Outlet />;
};
